import React, { Component } from "react";
// import { connect } from "react-redux";
import { Button, TextField, Link } from "@material-ui/core";
import Image from "../assets/3275433.svg";
// import { fetchMethod } from "../FetchMethod";
// import { resetPassword } from "./LoginQueries";
import "./login.css";
import { API_URL } from "../Config";
import SnackBarComponent from "../SnackBar/SnackBar";

class ChangePassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: "",
      open: false,
      severity: "",
      alertmsg: "",
      newPassword: "",
      confirmPassword: "",
      newPasswordErrorText: "",
      confirmPasswordErrorText: "",
      mainErrorText: "",
      disabled: false,
    };
  }
  UNSAFE_componentWillMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
    }
  }
  handleChange = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value, mainErrorText: "" });
    if (name === "newPassword") this.setState({ newPasswordErrorText: "" });
    else this.setState({ confirmPasswordErrorText: "" });
  };
  validateForm = () => {
    let {
      newPassword,
      confirmPassword,
      newPasswordErrorText,
      confirmPasswordErrorText,
      mainErrorText,
    } = this.state;
    if (!newPassword) {
      newPasswordErrorText = "Please enter new password";
    }
    // if(newPassword.length >=6){
    //   newPasswordErrorText ="Please choose a password with at least 8 characters."
    // }
    if (!confirmPassword) {
      confirmPasswordErrorText = "Please enter confirm password";
    }
    // if(confirmPassword.length >=6){
    //   mainErrorText ="Please choose a password with at least 8 characters."
    // }
    if (newPassword !== confirmPassword && newPassword && confirmPassword) {
      mainErrorText = "Password does not match";
    }
    if (!newPasswordErrorText && !confirmPasswordErrorText && !mainErrorText) {
      return true;
    } else {
      this.setState({
        confirmPasswordErrorText,
        newPasswordErrorText,
        mainErrorText,
      });
      return false;
    }
  };
  handleClose = () => {
    this.setState((prevState) => {
      return {
        open: !prevState.open,
        alertmsg: prevState.open ? "" : prevState.alertmsg,
      };
    });
  };
  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  onSubmit = (e) => {
    e.preventDefault();
    if (this.validateForm()) {
      this.setState({ disabled: true });
      fetch(
        `${API_URL}/api/Userdata/reset-password-2fa?accesstoken=${localStorage.getItem(
          "refreshtoken"
        )}&newpassword=${this.state.newPassword}`,
        {
          method: "POST",
          mode: "cors",
          body: JSON.stringify({
            // query: Query,
            // variables: Variables,
          }),
          headers: {
            "Content-type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then((res) => {
          this.setState({ disabled: false });
          if (res.status === "success") {
            localStorage.removeItem("refreshtoken");
            localStorage.removeItem("email");
            this.props.history.push("/");
          } else {
            this.setState({
              open: true,
              severity: "error",
              alertmsg: res.error.message,
              timer: 3000,
            });
          }
        })
        .catch((e) => {
          this.setState({
            disabled: false,
            open: true,
            severity: "error",
            alertmsg: e.message,
            timer: 3000,
          });
        });
    } else {
    }
    // }
  };

  goBack = () => {
    this.props.history.push("/");
  };
  BacktoLogin = () => {
    localStorage.clear();
  };
  render() {
    localStorage.setItem("email", this.state.email);
    return (
      <div>
        <div className="logoimg">
          <img alt="" src={Image} />
        </div>
        <div className="forgotMidSection">
          <h4>CHANGE PASSWORD</h4>
        </div>
        <form noValidate onSubmit={this.onSubmit}>
          <TextField
            value={this.state.newPassword}
            margin="normal"
            fullWidth
            id="newPassword"
            name="newPassword"
            autoComplete="newPassword"
            autoFocus
            onChange={this.handleChange}
            helperText={this.state.newPasswordErrorText}
            type="password"
            label="New Password"
          />
          <TextField
            value={this.state.confirmPassword}
            margin="normal"
            fullWidth
            id="confirmPassword"
            name="confirmPassword"
            autoComplete="confirmPassword"
            onChange={this.handleChange}
            helperText={this.state.confirmPasswordErrorText}
            type="password"
            label="Confirm Password"
          />
          {this.state.mainErrorText ? (
            <div className="connectionError">
              <p>{this.state.mainErrorText}</p>
            </div>
          ) : (
            ""
          )}

          <Button
            fullWidth
            variant="contained"
            color="primary"
            type="submit"
            disabled={this.state.disabled}
          >
            Save
          </Button>
          <span className="backtologin">
            <Link href="/" variant="body2" onClick={this.BacktoLogin}>
              Back to Login Page
            </Link>
          </span>
        </form>

        {this.state.open ? (
          <SnackBarComponent
            severity={this.state.severity}
            open={this.state.open}
            alertmsg={this.state.alertmsg}
            handleClose={this.handleClose}
          />
        ) : (
          ""
        )}
      </div>
    );
  }
}
export default ChangePassword;
